import Landing from './Landing';

export default {
  name: 'Landing',
  location: '/',
  component: Landing,
};
